import { render, staticRenderFns } from "./proReviewDecisionMaking2021.vue?vue&type=template&id=35991798&scoped=true&"
import script from "./proReviewDecisionMaking2021.vue?vue&type=script&lang=js&"
export * from "./proReviewDecisionMaking2021.vue?vue&type=script&lang=js&"
import style0 from "./proReviewDecisionMaking2021.vue?vue&type=style&index=0&id=35991798&scoped=true&lang=css&"
import style1 from "./proReviewDecisionMaking2021.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35991798",
  null
  
)

export default component.exports